export function makePublicPathUrl(url: string) {
  const base = process.env.REACT_APP_USE_ABSOLUTE_PATHS ? url.trim() : `/${process.env.PUBLIC_URL}/${url.trim()}`

  return base.replace(/\/\//g, '/').replace(/\/\//g, '/').replace(/\/\//g, '/')
}

export const basePath = `/${window.location.pathname.split('/').filter(Boolean)[0] || ''}`

export function getShopApiUrl(path: string) {
  const url = new URL(`${process.env.REACT_APP_BLANCO_SHOP_API}/${path}`, location.origin)

  return url
}

export function getRegistrationApiUrl(path: string) {
  const url = new URL(`${process.env.REACT_APP_BLANCO_PRODUCT_REGISTRATION_API}/${path}`, location.origin)

  return url
}
